import { GenericUiAlertFactory } from "../../Budgets/_generics";

export const UiAlertsStore = GenericUiAlertFactory("COMMON");